import { render } from "./GroupChatView.vue?vue&type=template&id=7d995852"
import script from "./GroupChatView.vue?vue&type=script&lang=js"
export * from "./GroupChatView.vue?vue&type=script&lang=js"
script.render = render

export default script